import { useState } from "react";
import { Field, Label, Switch } from "@headlessui/react";

export default function ToggleButton({ toggleFunction }) {
  const [enabled, setEnabled] = useState(false);

  const handleToggle = (newState) => {
    setEnabled(newState);
    if (toggleFunction) toggleFunction(newState);
    console.log(newState);
  };

  return (
    <Field className="flex items-center">
      <Switch
        checked={enabled}
        onChange={handleToggle}
        className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2 ${
          enabled ? "bg-[var(--primary-color)]" : "bg-gray-200"
        }`}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out ${
            enabled ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </Switch>

      <Label as="span" className="ml-3 text-sm">
        <span className="font-medium text-gray-900">Available Only</span>{" "}
      </Label>
    </Field>
  );
}
